import { z } from "zod";

/** Stable machine-readable error codes. The UI maps these to translated messages. */
export const ErrorCode = z.enum([
  "validation_failed",
  "unauthorized",
  "forbidden",
  "not_found",
  "conflict",
  "rate_limited",
  "setup_required",
  "setup_already_done",
  "invalid_credentials",
  "invalid_invite",
  "invalid_code",
  "code_expired",
  "code_attempts_exceeded",
  "email_not_verified",
  "totp_required",
  "invalid_totp",
  "docker_unavailable",
  "image_missing",
  "container_busy",
  "account_not_connected",
  "project_not_running",
  "chat_busy",
  "browser_not_running",
  "run_failed",
  "purge_failed",
  "internal",
]);
export type ErrorCode = z.infer<typeof ErrorCode>;

export const ApiError = z.object({
  error: ErrorCode,
  message: z.string().optional(),
  details: z.unknown().optional(),
});
export type ApiError = z.infer<typeof ApiError>;
